exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".regionDropdownWrapper_2Suz9fdh {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 15px;\n}\n.regionDropdownWrapper_2Suz9fdh svg {\n  margin-right: 8px;\n  max-width: 12px;\n}\n.regionDropdownWrapper_2Suz9fdh select {\n  text-transform: uppercase;\n  color: #191919;\n  font-weight: 500;\n  line-height: 1;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n", ""]);

// exports
exports.locals = {
	"regionDropdownWrapper": "regionDropdownWrapper_2Suz9fdh"
};